<template>
  <v-card>
    <v-card-title class="bg-orange text-white d-flex justify-space-between align-center">
      <div>
        <v-icon start>mdi-account-multiple</v-icon>
        Gestión de Clientes
      </div>
      <v-btn color="white" variant="text" @click="openAddDialog">
        <v-icon start>mdi-account-plus</v-icon>
        Agregar Cliente
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="clients"
        :loading="loading"
        :items-per-page="10"
        class="elevation-1"
      >
        <template v-slot:no-data>
          <v-alert type="info" border="start" color="orange" variant="tonal">
            No hay clientes registrados actualmente.
          </v-alert>
        </template>

        <template v-slot:item.vigente="{ item }">
          <v-btn
            size="x-small"
            :color="item.vigente === 1 ? 'green' : 'red'"
            :text="item.vigente === 1 ? 'Vigente': 'No Vigente'"
          ></v-btn>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            icon="mdi-pencil"
            size="small"
            color="blue"
            variant="text"
            title="Editar Cliente"
            @click="openEditDialog(item)"
          />
          <v-btn
            icon="mdi-lock-outline"
            size="small"
            color="blue"
            variant="text"
            title="Editar Contraseña"
            @click="openEditPassword(item)"
          />
          <v-btn
            :icon="item.vigente === 1 ?  'mdi-check-circle' : 'mdi-close-thick'"
            size="small"
            :color="item.vigente === 1 ? 'green' : 'red'"
            variant="text"
            title="Actualizar Vigencia"
            @click="actualizarVigencia(item)"
          />
          <v-btn
            icon="mdi-delete"
            size="small"
            color="red"
            variant="text"
            title="Eliminar Cliente"
            @click="confirmDelete(item)"
          />
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Back to Panel -->
    <div class="text-center mt-6 mb-6">
      <v-btn
        to="/admin"
        variant="text"
        color="grey-darken-1"
        prepend-icon="mdi-arrow-left"
      >
        Volver al Panel
      </v-btn>
    </div>

    <!-- Add Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="bg-orange text-white">
          <span class="text-h5">Agregar Cliente</span>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="formData.cuit"
              label="CUIT"
              :rules="[rules.required]"
              variant="outlined"
              class="mb-4"
            />

            <v-text-field
              v-model="formData.mail"
              label="Email"
              :rules="[rules.email]"
              variant="outlined"
              class="mb-4"
            />

            <v-text-field
              v-model="formData.password"
              label="Contraseña"
              type="password"
              :rules="[rules.required]"
              variant="outlined"
              class="mb-4"
            />

            <!-- Rol fijo oculto -->
            <v-text-field
              v-model="rolFijo"
              label="Rol"
              variant="outlined"
              readonly
              hide-details
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" variant="text" @click="closeDialog">
            Cancelar
          </v-btn>
          <v-btn color="orange" variant="flat" @click="saveClient" :disabled="!valid">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Dialog-->
    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title class="bg-orange text-white">
          <span class="text-h5">Editar Cliente</span>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="formData.cuit"
              label="CUIT"
              :rules="[rules.required]"
              variant="outlined"
              class="mb-4"
            />

            <v-text-field
              v-model="formData.mail"
              label="Email"
              :rules="[rules.email]"
              variant="outlined"
              class="mb-4"
            />

            <!-- Rol fijo oculto -->
            <v-text-field
              v-model="rolFijo"
              label="Rol"
              variant="outlined"
              readonly
              hide-details
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" variant="text" @click="closeEditDialog">
            Cancelar
          </v-btn>
          <v-btn color="orange" variant="flat" @click="UpdateClient" :disabled="!valid">
            Guardar Cambios
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Pass Dialog-->
    <v-dialog v-model="passDialog" max-width="600px">
      <v-card>
        <v-card-title class="bg-orange text-white">
          <span class="text-h5">Editar Contraseña Cliente</span>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="formPass.password"
              label="Contraseña Actual"
              variant="outlined"
              class="mb-4"
              readonly
            />

            <v-text-field
              v-model="formPass.newPass"
              label="Nueva Contraseña"
              :rules="[rules.required]"
              variant="outlined"
              class="mb-4"
            />

            <!-- Rol fijo oculto -->
            <v-text-field
              v-model="rolFijo"
              label="Rol"
              variant="outlined"
              readonly
              hide-details
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" variant="text" @click="closePassDialog">
            Cancelar
          </v-btn>
          <v-btn color="orange" variant="flat" @click="UpdatePassClient" :disabled="!valid">
            Guardar Cambios
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h5">Confirmar Eliminación</v-card-title>
        <v-card-text>
          ¿Está seguro que desea eliminar este cliente?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" variant="text" @click="deleteDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="red" variant="flat" @click="deleteClient">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script setup>
import client from '@/store/modules/client'
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const headers = [
  { title: 'ID', key: 'id_usuario', sortable: true },
  { title: 'CUIT', key: 'cuit', sortable: true },
  { title: 'Email', key: 'mail', sortable: true },
  { title: 'Contraseña', key: 'password', sortable: false },
  { title: 'Estado', key: 'vigente', sortable: false , align: 'center' },
  { title: 'Acciones', key: 'actions', sortable: false, align: 'center' }
]

const clients = ref([])
const loading = ref(false)
const dialog = ref(false)
const editDialog = ref(false)
const deleteDialog = ref(false)
const passDialog = ref(false)
const editMode = ref(false)
const valid = ref(false)
const rolFijo = ref('Cliente')

const formData = ref({
  id_usuario: null,
  cuit: '',
  mail: '',
  password: '',
  id_role: 2 // 👈 siempre cliente
})

const formPass = ref({
  id_usuario: null,
  password: '',
  newPass: '',
  id_role: 2
})

const rules = {
  required: value => !!value || 'Campo requerido',
  email: value => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return !value || pattern.test(value) || 'Email inválido'
  }
}

const selectedClient = ref(null)

// 🚀 Llamado al Vuex
const fetchClients = async () => {
  loading.value = true
  const result = await store.dispatch("user/fetchClients")
  if (result?.success) {
    // Filtra solo los de rol CLIENTE
    const allClients = store.getters["user/getAllClients"]
    clients.value = allClients.filter(c => c.id_role === 2)
  } else {
    console.error("Error al obtener clientes:", result?.message)
  }
  loading.value = false
}

const openAddDialog = () => {
  formData.value = {
    id_usuario: null,
    cuit: '',
    mail: '',
    password: '',
    id_role: 2 // 👈 cliente fijo
  }
  dialog.value = true
}

const openEditDialog = (client) => {
  formData.value = {
    id_usuario: client.id_usuario,
    cuit: client.cuit,
    mail: client.mail,
    password: '',
    id_role: 2 // 👈 forzado a cliente
  }
  editDialog.value = true
}

const openEditPassword = (client) => {
  formPass.value = {
    id_usuario: client.id_usuario,
    password: client.password,
    newPass: '',
    id_role: 2
  }
  passDialog.value = true
}

const closeDialog = () => {
  dialog.value = false
  formData.value = {
    id_usuario: null,
    cuit: '',
    mail: '',
    password: '',
    id_role: 2
  }
}

const closeEditDialog = () => {
  editDialog.value = false
  formData.value = {
    id_usuario: null,
    cuit: '',
    mail: '',
    password: '',
    id_role: 2
  }
}

const closePassDialog = () => {
  passDialog.value = false
  formPass.value = {
    id_usuario: null,
    password: '',
    newPass: '',
    id_role: 2
  }
}

const saveClient = async () => {
  if (!valid.value) return
  loading.value = true
  const action = "addClient"
  const result = await store.dispatch(`user/${action}`, formData.value)
  if (result.success) {
    await fetchClients()
    dialog.value = false
  } else {
    alert(result.message || "Error al guardar el cliente")
  }
  loading.value = false
}

const UpdateClient = async () => {
  if (!valid.value) return
  loading.value = true
  const action = "updateClient"
  const result = await store.dispatch(`user/${action}`, formData.value)
  if (result.success) {
    await fetchClients()
    editDialog.value = false
  } else {
    alert(result.message || "Error al guardar los cambios")
  }
  loading.value = false
}

const UpdatePassClient = async () => {
  if (!valid.value) return
  loading.value = true
  const action = "passClient"
  const result = await store.dispatch(`user/${action}`, formPass.value)
  if (result.success) {
    await fetchClients()
    passDialog.value = false
  } else {
    alert(result.message || "Error al guardar los cambios")
  }
  loading.value = false
}

const actualizarVigencia = async (client) => {
  const nuevoEstado = client.vigente === 1 ? 0 : 1
  const result = await store.dispatch("user/toggleClientVigencia", {
    id_usuario: client.id_usuario,
    vigente: nuevoEstado
  })
  
  if (result.success) {
    await fetchClients()
  } else {
    alert(result.message || "Error al actualizar estado del cliente")
  }
}

const confirmDelete = (client) => {
  selectedClient.value = client
  deleteDialog.value = true
}

const deleteClient = async () => {
  loading.value = true
  const result = await store.dispatch("user/deleteClient", selectedClient.value.id_usuario)
  if (result.success) {
    await fetchClients()
    deleteDialog.value = false
  } else {
    alert(result.message || "Error al eliminar el cliente")
  }
  loading.value = false
}

onMounted(() => {
  fetchClients()
})
</script>